export default __webpack_public_path__ + "static/media/CA131A73-E662-4F45-A897-7EB540C45056.d73c3cd7.jpg";